module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.coverageDevelopment"
    }
  }), _vm._v("\n                    Udviklingen i DB / DB pr. time\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage.progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.coverage.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.coverage_progress_percent === 0 || props.row.coverage_progress_percent > -5 && props.row.coverage_progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'coverage_per_hour.progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.coverage_per_hour.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.coverage_per_hour_progress_percent === 0 || props.row.coverage_per_hour_progress_percent > -5 && props.row.coverage_per_hour_progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'projects_count') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.projects_count)) + "\n                            ")]) : (props.column.field == 'coverage_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.coverage_per_hour_total) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour_total < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour_total) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour_total) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(props.row.coverage_per_hour_total)) + " \n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 497252192)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    " + _vm._s(_vm.series[0].name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "apex-charts-wrapper"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.generateSeries(),
      "type": "line"
    }
  }) : _vm._e()], 1)])]) : _c('div', [_vm._v("\n                Vælg en opgavetype for at se fremgangen i en graf\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08f63da2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/projects/components/projectTypeGraphs.vue
// module id = 795
// module chunks = 0